import { useEffect, useRef } from "react";
import { Box, Button, Paper, Typography } from "@material-ui/core";
import { Link as RouterLink } from "react-router-dom";
import { isNativeCapacitorRuntime } from "../../services/nativeRuntime";
import { showManageSubscriptions } from "../../services/nativeSubscriptionManagement";
import "./delete-account.scss";

// Shown after a successful deletion and sign-out (iOS ruling B1 §9). Public: no session exists
// any more, and neither session guard redirects away from it.
export default function AccountDeletedPage() {
  const heading = useRef(null);
  const native = isNativeCapacitorRuntime();

  useEffect(() => {
    if (heading.current) heading.current.focus();
  }, []);

  return (
    <Box className="account-deleted-container">
      <Box className="account-deleted-content">
        <Paper elevation={0} className="delete-account-paper" component="section" aria-labelledby="account-deleted-title">
          <Typography variant="h5" component="h1" id="account-deleted-title" gutterBottom tabIndex={-1} ref={heading}>
            Your account was deleted
          </Typography>
          <Typography className="delete-account-lead">
            We deleted your QLearn account and its personal data, except the records our Privacy Policy describes.
            If your account had an email address, we're sending a confirmation to it.
          </Typography>
          <Typography>
            If you have a subscription from the App Store, Apple bills it until you cancel it in your Apple ID
            settings. If you sign in again, you'll start with a new, empty account.
          </Typography>
          <Box className="delete-account-actions">
            <Button component={RouterLink} to="/login" variant="contained" color="primary" className="delete-account-primary">
              Done
            </Button>
            {native && (
              <Button variant="outlined" className="delete-account-secondary" onClick={() => showManageSubscriptions()}>
                Manage App Store subscription
              </Button>
            )}
          </Box>
        </Paper>
      </Box>
    </Box>
  );
}
